<div class="page-busy page-busy-transparent" data-cy="pageBusy">
    <h1>
        <!-- use angular content projection to display spinner message
        see templates where app-full-page-spinner is injected to pass message in
        ex. app.component.html-->
        <ng-content></ng-content>
    </h1>
    <mat-spinner class="custom-spinner" [diameter]="100" color="accent"></mat-spinner>
</div>
